import React, { useState } from 'react';
import { Mail, Phone } from 'lucide-react';

const NeedAssistanceBanner = ({
    message = 'Contact support if any details on this page are incorrect.',
    email = 'support@example.com',
    phone = '+94 11 234 5678'
}) => {
    const [isHoveringPhone, setIsHoveringPhone] = useState(false);

    return (
        <footer className="w-full">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 p-5 bg-[#0a1120] rounded-xl text-white">

                {/* Left Section: Text */}
                <div className="flex flex-col">
                    <h4 className="text-[15px] font-semibold text-white">Need assistance?</h4>
                    <p className="text-slate-400 text-[13px] mt-0.5 font-light">
                        {message}
                    </p>
                </div>

                {/* Right Section: Buttons */}
                <div className="flex items-center gap-3">
                    {/* Email Button - Outlined */}
                    <a
                        href={`mailto:${email}`}
                        className="flex items-center gap-2 px-5 py-2.5 rounded-lg border border-slate-300 hover:bg-white/10 transition-colors duration-200"
                    >
                        <Mail size={18} strokeWidth={1.5} />
                        <span className="text-[15px] font-medium">Email Us</span>
                    </a>

                    {/* Phone Button - Solid White with Hover Toggle */}
                    <a
                        href={`tel:${phone.replace(/\s/g, '')}`}
                        onMouseEnter={() => setIsHoveringPhone(true)}
                        onMouseLeave={() => setIsHoveringPhone(false)}
                        className="flex items-center gap-2 px-5 py-2.5 bg-white text-[#0a1120] rounded-lg hover:bg-slate-100 transition-all duration-300 min-w-[120px] justify-center"
                    >
                        <Phone size={18} strokeWidth={2} />
                        <span className="text-[15px] font-bold">
                            {isHoveringPhone ? phone : "Call Us"}
                        </span>
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default NeedAssistanceBanner;